
import { PropTypes } from 'prop-types';
const GraduatedCard = ({quote,name,course,img}) => {
  return (
    <div className="w-60 2xl:w-96 h-[20rem] 2xl:h-[30rem]  relative border shrink-0 snap-center group select-none  bg-slate-500/30 rounded-3xl overflow-hidden bg-cover bg-no-repeat bg-center" style={{backgroundImage:`url('${img}')`}}>
        <div className='absolute w-full h-full top-0 bg-gradient-to-b from-black/20 to-black/40 z-20 opacity-0 group-hover:opacity-100 transition-all duration-500'></div>
        <div className="absolute bottom-0 w-full h-2/5 2xl:h-1/3 bg-gradient-to-b from-black/30 to-black/80 bg-opacity-10 p-4">
            <div className="flex flex-col justify-start h-full gap-3 ">
                <h1 className="text-white flex-1 flex items-start  text-justify font-bold text-sm 2xl:text-lg">&ldquo;{quote}&rdquo;</h1>
                <p className="text-white flex-1 text-[9px]  flex items-start flex-col 2xl:text-sm">{name} <span>{course}</span></p>
            </div>
        </div>

    </div>
  )
}
GraduatedCard.propTypes = {
    quote: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    course: PropTypes.string,
    img: PropTypes.string.isRequired
}
export default GraduatedCard